import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// Wrapper container to maintain consistent height
export const BreakTimesWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  borderBottom: '0.5px solid rgba(84, 84, 88, 0.65)',
  padding: theme.spacing(2, 0),
  minHeight: theme.spacing(18), // Consistent height to prevent flash of shorter container during loading
}));

// Style for the message container (loading, empty state, etc.)
export const MessageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '97%',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4, 0),
  gap: theme.spacing(1),
  height: '100%',
}));

// Container for the breaks section
export const BreaksContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 0, 0, 2),
  height: '100%',
}));

// Status-based text styling
export const StatusText = styled(Typography)(({ status = 'info', theme }) => {
  switch (status) {
    case 'info':
      return { color: theme.palette.info.main };
    case 'success':
      return { color: theme.palette.success.main };
    case 'warning':
      return { color: theme.palette.warning.main };
    case 'error':
      return { color: theme.palette.error.main };
    default:
      return { color: theme.palette.info.main };
  }
});

// Container for a single row of time-related items
export const BreakTitleAndStatusContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

// Container for individual break items
export const BreakContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: theme.spacing(2),
}));
